import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import CalendarHeader from './CalendarHeader';
import CalendarGrid from './CalendarGrid';
import EventModal from './EventModal';
import { eventsData } from '../data/events';

const Calendar = () => {
  const [currentDate, setCurrentDate] = useState(dayjs());
  const [events, setEvents] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [showEventModal, setShowEventModal] = useState(false);

  useEffect(() => {
    // Load events data
    setEvents(eventsData);
  }, []);

  const handlePrevMonth = () => {
    setCurrentDate(currentDate.subtract(1, 'month'));
  };

  const handleNextMonth = () => {
    setCurrentDate(currentDate.add(1, 'month'));
  };

  const handleDateClick = (date) => {
    setSelectedDate(date);
    const dateEvents = events.filter(event => 
      dayjs(event.date).format('YYYY-MM-DD') === date.format('YYYY-MM-DD')
    );
    if (dateEvents.length > 0) {
      setShowEventModal(true);
    }
  };

  const handleCloseModal = () => {
    setShowEventModal(false);
    setSelectedDate(null);
  };

  return (
    <div className="bg-white rounded-2xl shadow-xl overflow-hidden max-w-6xl mx-auto">
      <CalendarHeader 
        currentDate={currentDate}
        onPrevMonth={handlePrevMonth}
        onNextMonth={handleNextMonth}
      />
      <CalendarGrid 
        currentDate={currentDate}
        events={events}
        onDateClick={handleDateClick}
      />
      {showEventModal && selectedDate && (
        <EventModal
          date={selectedDate}
          events={events.filter(event => 
            dayjs(event.date).format('YYYY-MM-DD') === selectedDate.format('YYYY-MM-DD')
          )}
          onClose={handleCloseModal}
        />
      )}
    </div>
  );
};

export default Calendar;